<template>
  <div class="app ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />

    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <skeleton />
    </v-sheet>

    <div v-show="!showSkeleton">
      <div class="text-h4 mb-2" v-if="edicao === 'false' || !edicao">Cadastro de Fila</div>

      <v-form ref="form">
        <v-card>
          <v-app-bar dark elevation="0" color="blue" dense class="text-header-5 mb-8">Configurações da Fila</v-app-bar>

          <v-row class="ma-2" dense>
            <v-col>
              <v-text-field
                outlined
                dense
                label="Descrição"
                counter="30"
                v-model="form.description"
                :error-messages="descriptionErrors"
                @input="$v.form.description.$touch()"
                @blur="$v.form.description.$touch()"
                :disabled="permissaoVisualizar"
              />
            </v-col>
            <v-col>
              <v-text-field
                outlined
                dense
                type="number"
                label="Tempo de Toque (seg)"
                hint="Tempo de toque em cada ramal"
                persistent-hint
                v-model="form.timeout"
                :error-messages="timeoutErrors"
                @input="$v.form.timeout.$touch()"
                @blur="$v.form.timeout.$touch()"
                :disabled="permissaoVisualizar"
              />
            </v-col>
            <v-col>
              <v-text-field
                outlined
                dense
                type="number"
                label="Tempo de Retorno (seg)"
                hint="Tempo para voltar a tocar em algum ramal"
                persistent-hint
                v-model="form.retry"
                :error-messages="retryErrors"
                @input="$v.form.retry.$touch()"
                @blur="$v.form.retry.$touch()"
                :disabled="permissaoVisualizar"
              />
            </v-col>
            <v-col>
              <v-text-field
                outlined
                dense
                type="number"
                label="Nível de serviço (seg)"
                v-model="form.tempoEspera"
                :error-messages="tempoEsperaErrors"
                @input="$v.form.tempoEspera.$touch()"
                @blur="$v.form.tempoEspera.$touch()"
                :disabled="permissaoVisualizar"
              />
            </v-col>
          </v-row>
          <v-row class="ma-2" dense>
            <v-col cols="3">
              <v-select
                outlined
                dense
                label="Estratégia"
                v-model="form.strategy"
                :items="strategy"
                :error-messages="strategyErrors"
                @input="$v.form.strategy.$touch()"
                @blur="$v.form.strategy.$touch()"
                :disabled="permissaoVisualizar"
              />
            </v-col>
            <v-col cols="3">
              <v-select
                outlined
                dense
                label="Música de Espera"
                v-model="form.music"
                :items="musicasEspera"
                :error-messages="musicErrors"
                @input="$v.form.music.$touch()"
                @blur="$v.form.music.$touch()"
                :disabled="permissaoVisualizar"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                outlined
                dense
                type="number"
                label="Máximo de Ligações"
                hint="Máximo de ligações na fila."
                persistent-hint
                v-model="form.maxlen"
                :error-messages="maxlenErrors"
                @input="$v.form.maxlen.$touch()"
                @blur="$v.form.maxlen.$touch()"
                :disabled="permissaoVisualizar"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                outlined
                dense
                type="number"
                label="Prioridade"
                v-model="form.priority"
                :error-messages="priorityErrors"
                @input="$v.form.priority.$touch()"
                @blur="$v.form.priority.$touch()"
                :disabled="permissaoVisualizar"
              />
            </v-col>
          </v-row>
        </v-card>

        <v-card>
          <v-app-bar dark elevation="0" color="blue" dense class="text-header-5 mb-8">
            Configurações do Operador na Fila
          </v-app-bar>

          <v-row class="ma-2" dense>
            <v-col cols="3">
              <v-text-field
                outlined
                dense
                type="number"
                label="Tempo de Descanso (seg)"
                hint="Tempo para receber outra ligação"
                persistent-hint
                v-model="form.wrapuptime"
                :error-messages="wrapuptimeErrors"
                @input="$v.form.wrapuptime.$touch()"
                @blur="$v.form.wrapuptime.$touch()"
                :disabled="permissaoVisualizar"
              />
            </v-col>
            <v-col cols="3">
              <v-select
                outlined
                dense
                label="Áudio para Operador"
                v-model="form.announce"
                :items="musicasOperador"
                :disabled="permissaoVisualizar"
              />
            </v-col>
          </v-row>
          <v-row dense class="ma-2">
            <!-- <v-col cols="3">
              <div class="text-caption">Pausar ramal após ligação?</div>
              <v-switch dense v-model="autopause" :label="autopause ? 'Sim' : 'Não'" />
            </v-col> -->
            <v-col cols="3">
              <div class="text-caption">Tocar mesmo se ramal ocupado?</div>
              <v-switch dense v-model="ringinuse" :label="ringinuse ? 'Sim' : 'Não'" :disabled="permissaoVisualizar" />
            </v-col>
            <v-col cols="3">
              <div class="text-caption">Informa tempo de espera do cliente?</div>
              <v-switch
                dense
                v-model="reportholdtime"
                :label="reportholdtime ? 'Sim' : 'Não'"
                :disabled="permissaoVisualizar"
              />
            </v-col>
          </v-row>
        </v-card>
        <v-card>
          <v-app-bar dark elevation="0" color="blue" dense class="text-header-5 mb-8"
            >Configurações do Cliente na Fila</v-app-bar
          >
          <v-row class="ma-2" dense>
            <v-col cols="3">
              <v-select
                outlined
                dense
                label="Aviso de Posição Fila"
                v-model="form.announcePosition"
                :items="announcePosition"
                :error-messages="announcePositionErrors"
                @input="$v.form.announcePosition.$touch()"
                @blur="$v.form.announcePosition.$touch()"
                :disabled="permissaoVisualizar"
              />
            </v-col>
            <v-col cols="3">
              <v-select
                outlined
                dense
                label="Aviso Tempo de Espera"
                v-model="form.announceHoldTime"
                :items="announceHoldTime"
                :disabled="form.announcePosition === 'no' || permissaoVisualizar"
                :error-messages="announceHoldTimeErrors"
                @input="$v.form.announceHoldTime.$touch()"
                @blur="$v.form.announceHoldTime.$touch()"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                outlined
                dense
                label="Referência"
                type="number"
                v-model="form.announcePositionLimit"
                :disabled="verificaReferencia || permissaoVisualizar"
                :error-messages="announcePositionLimitErrors"
                @input="$v.form.announcePositionLimit.$touch()"
                @blur="$v.form.announcePositionLimit.$touch()"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                outlined
                dense
                type="number"
                label="Tempo entre Avisos (seg)"
                v-model="form.announceFrequency"
                :disabled="(form.announceHoldTime !== 'yes' && form.announcePosition === 'no') || permissaoVisualizar"
                :error-messages="announceFrequencyErrors"
                @input="$v.form.announceFrequency.$touch()"
                @blur="$v.form.announceFrequency.$touch()"
              />
            </v-col>
          </v-row>
          <v-row align="baseline" class="ma-2" dense>
            <v-col cols="4">
              <v-select
                outlined
                dense
                multiple
                label="Áudios de Propaganda"
                v-model="form.periodicAnnounce"
                :items="periodicAnnounce"
                :disabled="permissaoVisualizar"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                outlined
                dense
                type="number"
                label="Tempo entre Propagandas (seg)"
                v-model="form.periodicAnnounceFrequency"
                :disabled="form.periodicAnnounce.length === 0 || permissaoVisualizar"
                :error-messages="periodicAnnounceFrequencyErrors"
                @input="$v.form.periodicAnnounceFrequency.$touch()"
                @blur="$v.form.periodicAnnounceFrequency.$touch()"
              />
            </v-col>
            <v-col cols="4">
              <v-switch
                dense
                v-model="randomPeriodicAnnounce"
                label="Tocar as propagandas de forma aleatória?"
                :disabled="!(form.periodicAnnounce.length > 1) || permissaoVisualizar"
              />
            </v-col>
          </v-row>
        </v-card>
        <div v-for="n in 3" :key="n">
          <v-divider vertical />
        </div>
        <FixedButtons
          @salvar="salvar()"
          @cancelar="cancelar"
          :pararLoader="pararLoader"
          :disableSaveButton="permissaoVisualizar"
        />
      </v-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'

import FixedButtons from '@/componentes/FixedButtons'
import Snackbar from '@/componentes/Snackbar'
import { registerVuexModule } from '@/utils/vuexUtils'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import filasStore from '../_store'
import Skeleton from '../_components/Skeleton'
import { validateData, validateComputed } from '../_validates/validatesFilas'
import { cadastroFilasMethods, cadastroFilasWatchers } from '../_util/filasMethodsAndWatchers'

export default {
  name: 'CadastroFila',
  props: {
    edicao: String,
    _id: String,
  },
  components: { Snackbar, Skeleton, FixedButtons },
  mixins: [validationMixin],

  data: () => ({
    text: '',
    snackbar: false,
    showSkeleton: false,
    desativado: false,
    hideButtons: false,
    show: false,
    form: {
      description: '',
      music: 'default',
      strategy: 'random',
      timeout: '15',
      retry: '1',
      autopause: 'no',
      wrapuptime: '5',
      ringinuse: 'no',
      maxlen: '0',
      announce: 'no',
      announceFrequency: '120',
      announceHoldTime: 'no',
      announcePositionLimit: '5',
      announcePosition: 'no',
      reportholdtime: 'no',
      priority: '0',
      tempoEspera: '',
      periodicAnnounce: [],
      periodicAnnounceFrequency: '120',
      randomPeriodicAnnounce: 'yes',
    },
    musicasEspera: [{ text: 'default', value: 'default' }],
    musicasOperador: [{ text: '', value: 'no' }],
    periodicAnnounce: [],
    announcePosition: [
      { text: 'Não', value: 'no' },
      { text: 'Sim', value: 'yes' },
      { text: 'A partir da referência', value: 'more' },
      { text: 'Abaixo da referência', value: 'limit' },
    ],
    strategy: [
      { text: 'Aleatoriamente', value: 'random' },
      { text: 'Atendeu menos chamadas', value: 'fewestcalls' },
      { text: 'Disponível por mais tempo', value: 'leastrecent' },
      { text: 'Tocar todos', value: 'ringall' },
    ],
    announceHoldTime: [
      { text: 'Sim', value: 'yes' },
      { text: 'Não', value: 'no' },
      { text: 'Apenas uma vez', value: 'once' },
    ],
    autopause: false,
    ringinuse: false,
    reportholdtime: false,
    randomPeriodicAnnounce: true,
    permissaoVisualizar: false,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('cadastroFilaModuleCallCenterStore', ['getFila', 'getAudios', 'getMusicasEmEspera']),

    verificaReferencia() {
      if (this.form.announcePosition === 'no' || this.form.announcePosition === 'yes') {
        return true
      } else {
        return false
      }
    },
  },
  async created() {
    this.showSkeleton = true
    registerVuexModule(this.$store, 'cadastroFilaModuleCallCenterStore', filasStore)

    await Promise.all([this.listarAudios(), this.listarMusicasEmEspera()])

    const audios = this.getAudios.map(audio => ({ text: audio.description, value: audio._id }))
    const musicasEmEspera = this.getMusicasEmEspera.map(musica => ({ text: musica.description, value: musica._id }))

    this.musicasOperador = [...this.musicasOperador, ...audios]
    this.periodicAnnounce = [...this.periodicAnnounce, ...audios]
    this.musicasEspera = [...this.musicasEspera, ...musicasEmEspera]

    if (this.edicao === 'true') {
      this.desativado = true

      this.form = Object.assign({}, this.getFila)
      if (this.form.autopause === 'yes') {
        this.autopause = true
      }
      if (this.form.ringinuse === 'yes') {
        this.ringinuse = true
      }
      if (this.form.reportholdtime === 'yes') {
        this.reportholdtime = true
      }
      if (this.form.randomPeriodicAnnounce === 'no') {
        this.randomPeriodicAnnounce = false
      }
    }

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()

    if (arrayPermissions.includes(process.env.VUE_APP_CALLCENTER_CADASTRO_FILA_VISUALIZAR_CONDICIONADO)) {
      this.permissaoVisualizar = true
    }
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('cadastroFilaModuleCallCenterStore', ['listarAudios', 'listarMusicasEmEspera']),
    ...cadastroFilasMethods,
    ...obtainUserPermissions,
  },
  watch: {
    ...cadastroFilasWatchers,
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
